<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div
            class="d-flex align-items-center flex-column flex-md-row"
            style="gap: 5px"
          >
            <div class="col-12 col-md-2 px-0">
              <bita-bootbutton
                v-if="!showForm && $acl.can('create', 'requests')"
                type="primary px-4"
                title="درخواست حمل عادی"
                icon="fas fa-plus-square"
                class="w-100"
                @click.native="statusChangeModalFastCreate"
              />
            </div>
            <div v-if="isSilver" class="w-100">
              <bita-bootbutton
                v-if="!showForm && $acl.can('create', 'requests')"
                type="primary px-4"
                title="درخواست حمل پیشرفته"
                class="w-100"
                icon="fas fa-lock"
                @click.native="handleModalCreate"
              />
            </div>
            <div v-else class="col-12 col-md-2 px-0">
              <bita-bootbutton
                v-if="!showForm && $acl.can('create', 'requests')"
                type="primary px-4"
                title="درخواست حمل پیشرفته"
                class="w-100"
                icon="fas fa-plus-square"
                @click.native="handleModalCreate"
              />
            </div>
            <div class="col-12 col-md-2 px-0">
              <bita-bootbutton
                v-if="!showForm && $acl.can('create', 'requests')"
                type="primary px-4"
                title="درخواست حمل تنظیم شده"
                class="w-100"
                icon="fas fa-lock"
                @click.native="handleFromConfigCreate"
              />
            </div>
            <state-filter
              v-model="filter.state_id"
              :allowedStates="[71, 46, 1, 33, 34, 35, 65]"
              @input="loadData"
            />
          </div>
          <div class="col-12 col-md-2 px-0 mt-2">
            <bita-bootbutton
              icon="fas fa-filter"
              type="success"
              class="w-100"
              title="فیلتر بیشتر"
              @click.native="toggleFilters"
            />
          </div>
          <div style="text-align: center; margin-bottom: 20px;">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <bita-select
                        type="vehicle_type_parent"
                        name="vehicle_type_parent"
                        label="دسته بندی نوع ماشین"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="vehicleTypeParent"
                        data-text-field="name"
                        data-value-field="id"
                        @change="getVehicleTypeChildren"
                      />
                      <Spinner
                        :is-loading="isLoadingVehicleType"
                        class-name="col-lg-2"
                        styleName="align-self: center;"
                      />

                      <bita-select
                        v-show="isLoadingVehicleType === false"
                        type="vehicle_type"
                        name="vehicle_type"
                        label="نوع ماشین"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="vehicleType"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filter.vehicle_type"
                        @change="(e) => requestSearch(e)"
                      />

                      <bita-select
                        v-if="$acl.isSuperAdmin"
                        type="user_id"
                        name="user_id"
                        label="ایجاد کننده"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="users"
                        data-text-field="full_name"
                        data-value-field="id"
                        v-model="filter.user_id"
                        @change="(e) => requestSearch(e)"
                      />
                      <bita-select
                        v-if="$acl.isSuperAdmin"
                        type="salon"
                        name="salon"
                        label="سالن"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="salons"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filter.salon_id"
                        @change="(e) => requestSearch(e)"
                      />
                      <bita-select
                        v-if="this.isLoadingAllCities === false"
                        name="citiesOrgin"
                        label="شهر مبدا"
                        ref="citiesOrginDropDown"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="AllcitiesOrgin"
                        data-text-field="label"
                        data-value-field="id"
                        v-model="filter.origin_id"
                        @change="(e) => requestSearch(e)"
                      />
                      <bita-spinner
                        :is-loading="isLoadingAllCities"
                        class-name="col-lg-2"
                        styleName="align-self: center;"
                      />
                      <bita-select
                        v-if="!isLoadingAllCities"
                        name="citiesDestination"
                        label="شهر مقصد"
                        ref="citiesDestinationDropDown"
                        rules
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="AllcitiesDestination"
                        data-text-field="label"
                        data-value-field="id"
                        v-model="filter.destination_id"
                        @change="(e) => requestSearch(e)"
                      />
                      <bita-spinner
                        :is-loading="isLoadingAllCities"
                        class-name="col-lg-2"
                        styleName="align-self: center;"
                      />
                      <bita-datepicker
                        ref="fromdate"
                        type="date"
                        id="fromDate"
                        validation-container-class="col-lg-2"
                        name="from-date"
                        label="از تاریخ"
                        inputClass="form-control"
                        v-model="filter.fromDate"
                        @change="(e) => requestSearch(e)"
                      />
                      <bita-datepicker
                        ref="todate"
                        type="date"
                        id="toDate"
                        validation-container-class="col-lg-2"
                        name="to-date"
                        label="تا تاریخ"
                        inputClass="form-control"
                        v-model="filter.toDate"
                        @change="(e) => requestSearch(e)"
                      />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :on-data-binding="onDataBinding"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :props-cities-orgin="citiesOrgin"
      :props-cities-destination="citiesDestination"
      :props-loads="loads"
      :props-vehicle-types="vehicleTypes"
      :props-loading-times="loadingTimes"
      :props-carriers="carriers"
      :props-customers="customers"
      :props-salons="salons"
      :packages="packages"
      :waybill-states="waybillStates"
      :props-owners="owners"
      modal-id="edit-modal"
      title="ویرایش درخواست"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="copyModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :props-cities-orgin="citiesOrgin"
      :props-cities-destination="citiesDestination"
      :props-loads="loads"
      :props-vehicle-types="vehicleTypes"
      :props-loading-times="loadingTimes"
      :props-carriers="carriers"
      :props-customers="customers"
      :props-salons="salons"
      :packages="packages"
      :waybill-states="waybillStates"
      :action-copy="actionIsCopy"
      :props-owners="owners"
      modal-id="copy-modal"
      title="کپی از بار"
      @on-submit="handleCopyCreate"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :props-cities-orgin="citiesOrgin"
      :props-cities-destination="citiesDestination"
      :props-loading-times="loadingTimes"
      :props-carriers="carriers"
      :props-customers="customers"
      :props-salons="salons"
      :packages="packages"
      :props-owners="owners"
      :waybill-states="waybillStates"
      modal-id="create-modal"
      title="درخواست حمل پیشرفته"
      @on-submit="handleCreate"
    />
    <form-modal
      ref="createConfigModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :props-cities-orgin="citiesOrgin"
      :props-cities-destination="citiesDestination"
      :props-loading-times="loadingTimes"
      :props-carriers="carriers"
      :props-customers="customers"
      :props-salons="salons"
      :packages="packages"
      :props-owners="owners"
      :waybill-states="waybillStates"
      :triggered-from-special="triggeredFromSpecialButton"
      modal-id="config-modal"
      title=" درخواست حمل پیشرفته تنظیم شده"
      @on-submit="handleConfigCreate"
    />
    <fast-form-modal
      ref="fastCreateModal"
      :isLoading="isLoadingModal"
      :props-owners="owners"
      :props-salons="salons"
      modal-id="fast-create-modal"
      title="درخواست حمل عادی"
      @on-submit="handleFastCreate"
    />
    <status-modal
      ref="statusModal"
      :isLoading="isLoadingModal"
      :request-id="requestId"
      modal-id="status-modal"
      title=" تغییر وضعیت بار "
      @on-submit="handleStatus"
    />
    <request-logs
      ref="requestLogs"
      :isLoading="isLoadingModal"
      modal-id="request-logs"
      title="لاگ بار "
      @on-submit="handleStatus"
    />
    <drivers-list
      :props-data="deletedRequests"
      modal-id="drivers-list"
      title="اطلاعات رانندگان لغو شده"
    />

    <cancel-request
      ref="cancelRequestRef"
      @on-submit="handleCancelRequest"
      :props-silver="isSilver"
    />

    <request-message ref="requestMessageRef" />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" #default="{items: request}">
      <g-list>
        <g-list-item title="جزئیات" icon="fa fa-eye" @click="view(request)" />
        <g-list-item
          v-if="filter.state_id == 65"
          title="نمایش پیام"
          icon="fas fa-comment"
          @click="(event) => showRequestMessage(request, event)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('log', 'requests')"
          title="لاگ بار"
          icon="fas fa-search"
          @click="(event) => modalRequestLogs(request, event)"
        />
        <g-list-item
          v-if="!isCarrier_test"
          title="پردازش بار"
          icon="fa fa-list"
          @click="requestProcess(request)"
        />
        <g-list-item
          v-if="$acl.can('edit', 'requests') || isCarrier_test"
          title="ویرایش بار"
          icon="fa fa-edit"
          @click="edit(request)"
        />
        <g-list-item
          v-if="
            $acl.isSuperAdmin ||
              isCarrier_test ||
              $acl.can('change', 'requests-status')
          "
          title="تغییر وضعیت"
          icon="far fa-flag"
          @click="statusChangeModalStatus(request)"
        />
        <g-list-item
          v-if="$acl.can('delete', 'requests') || isCarrier_test"
          title="کنسل بار"
          icon="fa fa-times"
          @click="cancelRequest(request)"
        />
        <g-list-item
          v-if="$acl.can('create', 'requests')"
          title="کپی از بار"
          icon="fa fa-copy"
          @click="duplicateRequest(request)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import RequestsForm from "./Form";
import RequestsFastForm from "./FastForm";
import DriversList from "./DriversList";
import StateFilter from "../../../components/StateFilter";
import CancelRequest from "./CancelRequest";
import StatusModal from "./components/StatusModal";
import RequestLogs from "./components/RequestLogs";
import RequestMessage from "./RequestMessage.vue";
import GContextMenu from "../../../components/GContextMenu.vue";
import GList from "../../../components/listItem/GList.vue";
import GListItem from "../../../components/listItem/GListItem.vue";
import Spinner from "../../../components/Spinner";
import moment from "moment-jalaali";

export default {
  components: {
    Spinner,
    "form-modal": RequestsForm,
    "fast-form-modal": RequestsFastForm,
    StateFilter,
    DriversList,
    CancelRequest,
    StatusModal,
    RequestMessage,
    GContextMenu,
    GList,
    GListItem,
    RequestLogs,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت درخواست حمل بار",
          link: "/requests",
          active: true,
        },
      ],
      triggeredFromSpecialButton: false,
      actionIsCopy: false,
      requestId: null,
      citiesOrgin: [],
      citiesDestination: [],
      AllcitiesOrgin: [],
      AllcitiesDestination: [],

      loads: [],
      vehicleTypes: [],
      loadingTimes: [],
      carriers: [],
      customers: [],
      salons: [],
      packages: [],
      users: [],
      owners: [],
      deletedRequests: [],
      waybillStates: [
        { id: 14, name: "بارنامه دارد" },
        { id: 15, name: "بارنامه ندارد" },
        // {id: 16, name: 'بار داخل استان'}
      ],
      vehicleTypeParent: [],
      vehicleType: [],

      isLoadingVehicleType: false,
      showFilters: false,
      isLoadingGrid: false,
      isSilver: false,
      isGolden: false,
      isCarrier_test: false,
      isLoadingModal: false,
      showForm: false,

      createForm: {
        count: 0,
        origin_id: 0,
        origin_state_id: 0,
        destination_id: 0,
        destination_state_id: 0,
        vehicle_type_id: 0,
        category_vehicle_type_id: 0,
        load_id: 0,
        tonnage: 0,
        max_tonnage: 0,
        force_in_location_for_deliver: 0,
        force_in_location_for_reserve: 0,
        travel_time: 3,
        latlng: {
          origin: [31.83, 54.53],
          destination: [33, 49],
        },
        force_in_location: 0,
        salon_id: 0,
        category_loads_id: 0,
        loading_at: "",
        delivery_at: "",
        tools: "",
      },

      updateForm: {},
      filter: {
        state_id: 1,
      },
      pageSize: 30,
      currentPage: 1,
      isLoadingAllCities: false,
    };
  },
  computed: {
    gridColumns() {
      if (this.isCarrier_test) {
        return [
          { title: "#", template: this.getTemplateID, width: "80px" },
          {
            field: "creator",
            title: "ایجاد کننده",
            template: (e) => (e.creator ? e.creator.full_name : " - "),
            width: "100px",
          },
          {
            field: "load_data",
            title: "نوع بار",
            template: (e) => (e.load_data ? e.load_data.name : " - "),
            width: "100px",
          },
          {
            field: "vehicle_type",
            title: "نوع ماشین",
            template: (e) => (e.vehicle_type ? e.vehicle_type.name : " - "),
            width: "100px",
          },
          {
            field: "origin",
            title: "مبدا",
            template: (e) =>
              `${e.origin.name} ${
                e.loading_from ? " / " + e.loading_from : ""
              }`,
            width: "100px",
          },
          {
            field: "destination",
            title: "مقصد",
            template: (e) =>
              `${e.destination.name} ${
                e.deliver_to ? " / " + e.deliver_to : ""
              }`,
            width: "100px",
          },
          {
            field: "salon_name",
            title: "سالن",
            template: (e) => (e.salon ? e.salon.name : " - "),
            width: "100px",
          },
          // {
          //   field: "waybill",
          //   title: "باربری",
          //   template: (e) => this.carriersNameTemplate(e),
          // },
          {
            field: "count",
            title: "تعداد",
            template: (e) =>
              e.count
                ? `${e.count} / ${e.completed_request_details_count}`
                : "-",
            width: "100px",
          },
          {
            field: "state",
            title: "وضعیت",
            template: (e) =>
              e.state && e.state.name ? `${e.state.name}` : "-",
            width: "100px",
          },
          {
            field: "loading_at",
            title: "تاریخ بارگیری",
            template: (e) =>
              e.loading_at ? this.$getJalaliDate(e.loading_at) : " - ",
            width: "100px",
          },
          {
            field: "expired_at",
            title: "تاریخ انقضا",
            template: (e) =>
              e.expired_at ? this.$getJalaliDateTime(e.expired_at) : "",
            width: "100px",
          },
          {
            field: "created_at",
            title: "تاریخ ایجاد",
            template: (e) =>
              e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
            width: "100px",
          },
          {
            title: "عملیات",
            width: 50,
            command: this.gridCommands(),
          },
        ];
      } else {
        return [
          { title: "#", template: this.getTemplateID, width: "50px" },
          {
            field: "creator",
            title: "ایجاد کننده",
            template: (e) =>
              e.creator && e.owner
                ? `${e.creator.full_name} / ${e.owner.name}`
                : " - ",
            width: "140px",
          },
          {
            field: "load_data",
            title: "نوع بار",
            template: (e) => (e.load_data ? e.load_data.name : " - "),
            width: "90px",
          },
          {
            field: "vehicle_type",
            title: "نوع ماشین",
            template: (e) => (e.vehicle_type ? e.vehicle_type.name : " - "),
            width: "90px",
          },
          {
            field: "origin",
            title: "مبدا",
            template: (e) =>
              `${e.origin.name} ${
                e.loading_from ? " / " + e.loading_from : ""
              }`,
            width: "90px",
          },
          {
            field: "destination",
            title: "مقصد",
            template: (e) =>
              `${e.destination.name} ${
                e.deliver_to ? " / " + e.deliver_to : ""
              }`,
            width: "90px",
          },
          {
            field: "salon_name",
            title: "سالن",
            template: (e) => (e.salon ? e.salon.name : " - "),
            width: "90px",
          },
          // {
          //   field: "waybill",
          //   title: "باربری",
          //   template: (e) => this.carriersNameTemplate(e),
          // },
          {
            field: "count",
            title: "تعداد",
            template: (e) =>
              e.count
                ? `${e.count} / ${e.completed_request_details_count}`
                : "-",
            width: "50px",
          },
          {
            field: "_priorities",
            title: "اولویت",
            template: (e) => {
              const data = e._priorities;

              const result = [];

              for (const priority in data) {
                const [, value] = priority.split("_");

                if (data[priority]) result.push(`${value}:${data[priority]} `);
              }

              return result;
            },
            width: "50px",
          },
          {
            field: "state",
            title: "وضعیت",
            template: (e) =>
              e.state && e.state.name ? `${e.state.name}` : "-",
            width: "90px",
          },
          {
            field: "loading_at",
            title: "تاریخ بارگیری",
            template: (e) =>
              e.loading_at ? this.$getJalaliDate(e.loading_at) : " - ",
            width: "90px",
          },
          {
            field: "expired_at",
            title: "تاریخ انقضا",
            template: (e) =>
              e.expired_at
                ? this.$getJalaliDateTimeToNewFormat(e.expired_at)
                : "",
            width: "90px",
          },
          {
            field: "created_at",
            title: "تاریخ ایجاد",
            template: (e) =>
              e.created_at
                ? this.$getJalaliDateTimeToNewFormat(e.created_at)
                : "",
            width: "90px",
          },
          {
            title: "عملیات",
            command: this.gridCommands(),
            width: "50px",
          },
        ];
      }
    },
  },
  mounted() {
    if (this.$acl.roles.find((e) => e === "silver-subscription")) {
      this.isSilver = true;
    }
    if (this.$acl.roles.find((e) => e === "silver-subscription")) {
      this.isSilver = true;
    }
    if (this.$acl.roles.find((e) => e === "golden-subscription")) {
      this.isGolden = true;
    }
    if (this.$acl.roles.find((e) => e === "carrier_test")) {
      this.isCarrier_test = true;
    }
    if (this.$acl.isBroker || this.$acl.isSuperAdmin || this.$acl.isSupportUser)
      this.getOwners();
    Promise.all([
      this.getVehicleTypes(0),
      this.getUsers(),
      this.getLoadingTimes(),
      this.getCarriers(),
      this.getCustomers(),
      this.getSalons(),
      this.getPackages(),
      this.getAllCity(),
    ]).then((res) => {
      let vehicleTypeParent = res[0].data;
      let users = res[1].data;
      let loadingTimes = res[2].data;
      let carriers = res[3].data;
      let customers = res[4].data;
      let salons = res[5].data;
      let packages = res[6].data;
      let Allcities = res[7].data;
      // let citiesDestination = res[7].data;
      // let waybillStates = res[4].data
      this.vehicleTypeParent = vehicleTypeParent;
      this.users = users;
      this.loadingTimes = loadingTimes;
      this.carriers = carriers;
      this.customers = customers;
      this.salons = salons;
      this.packages = packages;
      this.AllcitiesOrgin = Allcities;
      this.AllcitiesDestination = Allcities;

      // this.waybillStates = waybillStates
    });
  },

  methods: {
    toggleFilters() {
      this.showFilters = !this.showFilters;
      if (!this.showFilters) {
        this.filter = {};
        this.loadData();
        this.resetFilter();
      }
    },
    showRequestMessage(request, e) {
      e.stopPropagation();

      this.$refs.requestMessageRef.init(request.message || null);
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    resetFilters() {
      this.$refs.statesDropDown.emptyKendo();
    },
    onDataBinding: function(ev) {
      var vm = this;
      setTimeout(() => {
        var grid = $("#grid").data("kendoGrid");
        var items = ev.items;
        items.forEach(function(item) {
          var dataItem = item;
          var selector = $(`.k-master-row[data-uid=${item.uid}]`);
          if (dataItem.state && dataItem.state.color) {
            selector.css("background-color", `#${dataItem.state.color}`);
            selector.css("color", `${vm.$findBgColor(dataItem.state.color)}`);
          }
        });
      }, 500);
      this.record =
        (this.gpage - 1) * this.$refs.grid.$refs.datasource.pageSize;
      var grid = this.$refs.grid.$refs.grid.kendoWidget();
      // this.report.review == 2 ? grid.hideColumn(10) : "";
    },
    carriersNameTemplate(e) {
      if (!e || !e.carrier || !e.waybill) return "-";
      let cc = _.filter(e.carrier, function(o) {
        return o.created_at && o.created_at != null;
      });
      if (Number(e.waybill_state_id) == 14)
        return e.carrier && e.carrier.length > 0 ? e.carrier[0].name : "-";
      else if (Number(e.waybill_state_id) == 15)
        return collect(cc)
          .pluck("name")
          .filter((i) => i)
          .toArray()
          .join("-");
      else return "عدم نیاز";
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `requests?include=origin,destination,vehicleType,loadData,carrier,waybill,creator,state,owner&page=${this.currentPage}&page_size=${this.pageSize}`,
        url = this.$makeQueryStringForSpatie(baseUrl, this.filter, "&");
      this.$persistClient("get", url)
        .then((res) => {
          const data = res?.data?.data || [];

          res.data.data = data.map((item) => {
            item._priorities = item.priorities;

            return item;
          });

          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    hardDelete(e) {
      let request = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف کردن درخواست بار خود به شماره پیگیری ${request.tracking_code} از مبدا ${request.origin.province.name} / ${request.origin.name}  به مقصد  ${request.destination.province.name} / ${request.destination.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `requests/${request.id}/hard-delete`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.deletedRequests = res.data;
              if (this.deletedRequests.length > 0) {
                $("#drivers-list")
                  .modal({
                    backdrop: "static",
                    keyboard: false,
                  })
                  .modal("toggle");
              }
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    edit(request) {
      this.$refs.contextMenu.handleCloseModal();
      this.actionIsCopy = false;
      this.getRequest(request.id);
    },
    cancelRequest(request) {
      this.$refs.cancelRequestRef.init(request);
    },
    handleCancelRequest({ request, type }) {
      this.isLoadingGrid = true;

      this.$persistClient(
        "delete",
        `requests/${request.id}?cancel=${type === "all" ? "all" : "free"}`,
      )
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.deletedRequests = res.data;

          this.loadData();
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    //  duplicateRequest(request) {
    //     this.$alert(
    //       "question",
    //       `آیا از کپی بار از مبد${request.origin.province.name }  به مقصد ${request.origin.name}   اطمینان دارید؟`,
    //       "",
    //       {
    //         confirmButtonText: "بله",
    //       }
    //     ).then((result) => {
    //       if (result.value) {
    //         this.isLoadingGrid = true;
    //         this.$persistClient("post", `requests/${request.id}/duplicate`)
    //           .then((res) => {
    //             this.$izitoast("success", "کپی بار با موفقیت انچام شد", "موفق");
    //             this.loadData();
    //           })
    //           .finally(() => {
    //             this.isLoadingGrid = false;
    //           });
    //       }
    //     });
    //   },
    statusChangeModalCopy() {
      $("#copy-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    duplicateRequest(request) {
      this.actionIsCopy = true;
      this.$refs.contextMenu.handleCloseModal();
      this.getRequest(request.id);
    },

    view(request) {
      this.$router.push(`/management/request/${request.id}/detail`);
    },
    getRequest(request_id) {
      var _this = this;

      this.isLoadingGrid = true;

      this.$persistClient(
        "get",
        `requests/${request_id}?include=origin,destination,vehicleType,loadData,carrier`,
      )
        .then((res) => {
          let response = res.data;
          axios
            .all([
              this.getLoads(
                response.load_data ? response.load_data.parent_id : 0,
              ),
              this.getVehicleTypes(response.vehicle_type.parent_id),
              this.getCityOrgin(response.origin.parent_id),
              this.getCityDestination(response.destination.parent_id),
            ])
            .then(
              axios.spread(function(
                loads,
                vehicleTypes,
                citiesOrgin,
                citiesDestination,
              ) {
                _this.loads = loads.data;
                _this.vehicleTypes = vehicleTypes.data;
                _this.citiesOrgin = citiesOrgin.data;
                _this.citiesDestination = citiesDestination.data;

                setTimeout(function() {
                  _this.updateForm = {
                    id: response.id,
                    user_id: response.user_id,
                    job: response.job && response.job.id ? 1 : 0,
                    job_type:
                      response.job && response.job.id
                        ? response.job.type
                        : null,
                    job_value:
                      response.job && response.job.id
                        ? response.job.value
                        : null,
                    request_type: Number(response.request_type),
                    customer_id: response.customer_id,
                    salon_id: response.salon_id,
                    is_private: response.is_private === 0 ? 2 : 1,
                    waybill_state_id: String(response.waybill_state_id),
                    count: response.count,
                    origin_id: response.origin_id,
                    origin_state_id: response.origin.parent_id,
                    destination_id: response.destination_id,
                    destination_state_id: response.destination.parent_id,
                    vehicle_type_id: response.vehicle_type_id,
                    category_vehicle_type_id: response.vehicle_type.parent_id,
                    load_id: response.load_id,
                    category_loads_id: response.load_data
                      ? response.load_data.parent_id
                      : null,
                    loading_at: response.loading_at,
                    delivery_at: response.delivery_at,
                    tools: response.tools ? response.tools : "",
                    loading_from: response.loading_from
                      ? response.loading_from
                      : "",
                    deliver_to: response.deliver_to ? response.deliver_to : "",
                    reserve_radius: response.reserve_radius,
                    request_code: response.request_code
                      ? response.request_code
                      : "",
                    short_description: response.short_description
                      ? response.short_description
                      : "",
                    tonnage: response.tonnage,
                    max_tonnage: response.max_tonnage,
                    check_tonnage: response.check_tonnage,
                    change_ticket: response.change_ticket,
                    force_in_location_for_reserve:
                      response.force_in_location_for_reserve,
                    force_in_location_for_deliver:
                      response.force_in_location_for_deliver,
                    is_good: response.is_good,
                    attend_time: response.attend_time,
                    attend_cycle: response.attend_cycle,
                    loading_time_id: response.loading_time_id,
                    expired_at: response.expired_at,
                    package_id: response.package_id,
                    price: response.price,
                    travel_time: response.travel_time,
                    force_in_location: response.force_in_location,
                    latitude: response.latitude,
                    longitude: response.longitude,
                    load_end_time: response.load_end_time,
                    load_start_time: response.load_start_time,
                    latlng: response.latlng,
                    address: response.address,
                    priorities: response.priorities,
                    _priorities: response.priorities,
                    is_exclusive: response.is_exclusive,
                    net_price: response.net_price ? response.net_price : "",
                    loading_fee: response.loading_fee,
                  };
                  if (_this.actionIsCopy) {
                    _this.updateForm.loading_at = moment()
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                    _this.updateForm.delivery_at = moment()
                      .add(2, "days")
                      .format("YYYY-MM-DD");
                    _this.updateForm.expired_at = moment()
                      .add(1, "days")
                      .format("YYYY-MM-DD 13:33:00");
                    _this.updateForm.check_tonnage = 0;
                  }
                  if (Number(response.waybill_state_id) == 14)
                    _this.updateForm.carrier_id =
                      response.carrier && response.carrier.length > 0
                        ? response.carrier[0].id
                        : null;
                  else if (Number(response.waybill_state_id) == 15)
                    _this.updateForm.carrier_id = collect(response.carrier)
                      .pluck("id")
                      .toArray();
                  _this.isLoadingGrid = false;
                  _this.actionIsCopy == true
                    ? _this.statusChangeModalCopy()
                    : _this.statusChangeModalEdit();
                }, 500);
              }),
            )
            .catch((err) => {})
            .finally(() => {});
        })
        .catch(() => {})
        .finally(() => {});
    },
    requestProcess(request) {
      this.$router.push(`/management/requests/${request.id}/request-process`);
    },
    getLoads(categoryId) {
      return this.$persistClient(
        "get",
        `loads?filter[parentItem]=${categoryId}`,
      );
    },
    getVehicleTypes(categoryId) {
      return this.$persistClient(
        "get",
        `vehicle-types?filter[parent]=${categoryId}`,
      );
    },
    getCityOrgin(stateId) {
      return this.$persistClient("get", `cities?filter[province]=${stateId}`);
    },

    getAllCity() {
      this.isLoadingAllCities = true;
      return this.$persistClient("get", `cities?filter[unProvince]=0`).finally(
        () => {
          this.isLoadingAllCities = false;
        },
      );
    },

    getCityDestination(stateId) {
      return this.$persistClient("get", `cities?filter[province]=${stateId}`);
    },
    getPackages() {
      return this.$persistClient("get", "packages");
    },
    getLoadingTimes() {
      return this.$persistClient("get", `loading-times`);
    },
    getCarriers() {
      return this.$persistClient("get", "carriers");
    },
    getCustomers() {
      return this.$persistClient("get", "customers");
    },
    getSalons() {
      return this.$persistClient("get", "salons");
    },
    getwaybillStates() {
      return this.$persistClient("get", "states?filter[type]=waybill");
    },
    getVehicleTypeChildren(e) {
      this.isLoadingVehicleType = true;
      this.$persistClient("get", `vehicle-types?filter[parent]=${e}`).then(
        (res) => {
          this.isLoadingVehicleType = false;
          this.vehicleType = res.data;
          return res;
        },
      );
    },
    getUsers() {
      return this.$persistClient("get", `requests/users`);
    },
    getOwners() {
      if (this.$acl.isSuperAdmin || this.$acl.isSupportUser)
        this.$persistClient("get", "owners").then((res) => {
          this.owners = res.data;
        });
      else if (this.$acl.isBroker)
        this.$persistClient(
          "get",
          `brokers/${this.$user.model.id}/owners`,
        ).then((res) => {
          this.owners = res.data;
        });
    },
    handleModalCreate() {
      this.statusChangeModalCreate();
      this.triggeredFromSpecialButton = false;
      this.isLoadingModal = true;
      Promise.all([
        this.getCityOrgin(this.$user.city ? this.$user.city.parent_id : 0),
      ]).then((res) => {
        this.citiesOrgin = res[0].data;
        this.isLoadingModal = false;
        this.$refs.createModal.setInitialData(this.createForm);
      });
    },
    handleFromConfigCreate() {
      this.statusChangeModalConfig();
      this.triggeredFromSpecialButton = true;
      this.isLoadingModal = true;
      Promise.all([
        this.getCityOrgin(this.$user.city ? this.$user.city.parent_id : 0),
      ]).then((res) => {
        this.citiesOrgin = res[0].data;
        this.isLoadingModal = false;
        this.$refs.createConfigModal.setInitialData(this.createForm);
      });
    },
    handleFastCreate(data) {
      this.isLoadingModal = true;
      this.$persistClient("post", "requests/admin", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);
          this.loadData();
          this.statusChangeModalFastCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleCreate(data) {
      this.isLoadingModal = true;
      // this.$persistClient("post", "requests", data)
      this.$persistClient("post", "requests/v2", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);
          this.createForm = {
            count: 0,
            origin_id: 0,
            origin_state_id: 0,
            destination_id: 0,
            destination_state_id: 0,
            vehicle_type_id: 0,
            category_vehicle_type_id: 0,
            salon_id: 0,
            customer_id: 0,
            user_id: 0,
            is_private: 0,
            load_id: 0,
            category_loads_id: 0,
            travel_time: 3,
            latlng: {
              origin: [31.83, 54.53],
              destination: [33, 49],
            },
            force_in_location: 0,
            loading_at: "",
            delivery_at: "",
            tools: "",
            package_id: 0,
            request_type: 0,
          };
          this.loadData();
          this.$refs.createModal.reset();
          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleConfigCreate(data) {
      this.isLoadingModal = true;
      // this.$persistClient("post", "requests", data)
      this.$persistClient("post", "requests/v2", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);
          this.createForm = {
            count: 0,
            origin_id: 0,
            origin_state_id: 0,
            destination_id: 0,
            destination_state_id: 0,
            vehicle_type_id: 0,
            category_vehicle_type_id: 0,
            salon_id: 0,
            customer_id: 0,
            user_id: 0,
            is_private: 0,
            load_id: 0,
            category_loads_id: 0,
            travel_time: 3,
            latlng: {
              origin: [31.83, 54.53],
              destination: [33, 49],
            },
            force_in_location: 0,
            loading_at: "",
            delivery_at: "",
            tools: "",
            package_id: 0,
            request_type: 0,
          };
          this.loadData();
          this.$refs.createConfigModal.reset();
          this.statusChangeModalConfig();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleCopyCreate(data) {
      this.isLoadingModal = true;
      // this.$persistClient("post", "requests", data)
      this.$persistClient("post", "requests/v2", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);
          this.createForm = {
            count: 0,
            origin_id: 0,
            origin_state_id: 0,
            destination_id: 0,
            destination_state_id: 0,
            vehicle_type_id: 0,
            category_vehicle_type_id: 0,
            salon_id: 0,
            customer_id: 0,
            user_id: 0,
            is_private: 0,
            load_id: 0,
            category_loads_id: 0,
            travel_time: 3,
            latlng: {
              origin: [31.83, 54.53],
              destination: [33, 49],
            },
            force_in_location: 0,
            loading_at: "",
            delivery_at: "",
            tools: "",
            package_id: 0,
            request_type: 0,
          };
          this.loadData();
          this.$refs.createModal.reset();
          this.statusChangeModalCopy();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    updateRequest(data) {
      this.isLoadingModal = true;

      this.$persistClient("patch", `requests/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            name: "",
            parent_id: "",
          };

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      if (data.price || data.price_net || data.customer_id) {
        this.$alert(
          "question",
          `درصورت تایید نهایی کلیه تغییرات برای بار های تکمیل نشده بروزرسانی می گردد.`,
          "",
          {
            confirmButtonText: "تایید",
          },
        ).then((result) => {
          if (result.value) {
            this.updateRequest(data);
          }
        });
      } else this.updateRequest(data);
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalConfig() {
      $("#config-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalFastCreate() {
      $("#fast-create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalStatus(data) {
      this.$refs.contextMenu.handleCloseModal();

      if (data.state.id != 46 && data.state.id != 71) {
        this.$izitoast(
          "error",
          "ناموفق",
          "شما دسترسی به تغییر وضعیت این بار را ندارید",
        );
        return;
      }
      this.requestId = data.id;
      $("#status-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    modalRequestLogs(data) {
      this.$refs.contextMenu.handleCloseModal();

      this.$refs.requestLogs.readData(data.id);

      $("#request-logs")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    handleStatus(e) {
      this.requestId = null;
      this.isLoadingModal = true;

      let data = {
        message: e.message,
        state_id: e.status == 2 ? 65 : 1,
      };

      this.$persistClient("patch", `requests/${e.request_id}/states`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
        })
        .finally(() => {
          this.isLoadingModal = false;
          this.$toggleModal("#status-modal");
        });
    },
    requestSearch: _.debounce(function() {
      this.loadData();
    }, 1000),
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
